import { Component, OnInit } from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';
import {RoleService} from '../../../services/role.service';
import {RevolutService} from '../../services/revolut.service';
import {RevolutTransactionLeg} from '../../../dto/revolut-transaction-leg';
import {Card} from '../../../dto/card';
import {toCardExpireDateString, toDateString, toDateTimeString} from '../../../providers/app-date-adapter';
import {formatCurrency, formatNumber, Location} from '@angular/common';
import {PrevNextModel} from '../../../models/prev-next-model';
import {getTableFilters} from '../../../helpers/storage-helper';
import {InvoiceSearch} from '../../../dto/invoice-search';
import {ToastService} from 'angular-toastify';
import {ConfirmDialogComponent} from '../../../shared/confirm-dialog/confirm-dialog.component';
import {CustomerChangeAddressStatusModel} from '../../../models/customer-change-address-status-model';
import {MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'app-revolut-details',
  templateUrl: './revolut-details.component.html',
  styleUrls: ['./revolut-details.component.css']
})
export class RevolutDetailsComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private roleService: RoleService,
    private revolutService: RevolutService,
    private location: Location,
    private _toastService: ToastService,
    private dialog: MatDialog,
  ) { }

  revolutTransactionLeg: RevolutTransactionLeg = null;
  revolutTransactionLegId: number = null;
  type = '';

  inv1MarkedAsPaid = false;
  invs1Found: InvoiceSearch[]|null = null;
  invSearch1Loading = false;
  invSearch1: string = null;

  inv2MarkedAsPaid = false;
  invs2Found: InvoiceSearch[]|null = null;
  invSearch2Loading = false;
  invSearch2: string = null;

  inv3MarkedAsPaid = false;
  invs3Found: InvoiceSearch[]|null = null;
  invSearch3Loading = false;
  invSearch3: string = null;

  inv4MarkedAsPaid = false;
  invs4Found: InvoiceSearch[]|null = null;
  invSearch4Loading = false;
  invSearch4: string = null;

  isBusy = false;



  prevNext: PrevNextModel;

  fields = [
    { header: 'Description', cell: (row: RevolutTransactionLeg) => `${row.description }` },
    { header: 'Reference', cell: (row: RevolutTransactionLeg) => `${row.reference }` },
    // { header: "Currency", cell: (row: RevolutTransactionLeg) => `${row.currency }` },
    { header: 'Amount', cell: (row: RevolutTransactionLeg) => `${row.currency} ${formatNumber(row.amount, 'en-US', '1.2-2')}` },
    { header: 'Possible First Name', cell: (row: RevolutTransactionLeg) => `${row.possibleFirstname == null ? '' :  row.possibleFirstname}` },
    { header: 'Possible Last Name', cell: (row: RevolutTransactionLeg) => `${row.possibleLastname == null ? '' : row.possibleLastname }` },
  ];

  returnBack() {
    this.router.navigate(['/loads/annual-fee']);
  }

    ngOnInit() {

    this.route.params.subscribe((params: Params) => {
      const idParam = params['id'];
      const typeParam = params['type'];

      this.revolutTransactionLegId = idParam;
      this.type = typeParam;
      this.clearData();
      this.refreshData();

    });

  }

  clearData() {
    this.revolutTransactionLeg = null;
    this.clearFound();

  }

  clearFound() {
    this.inv1MarkedAsPaid = false;
    this.invs1Found = null;
    this.invs2Found = null;
    this.inv2MarkedAsPaid = false;
    this.invSearch1 = null;
    this.invSearch2 = null;

    this.inv3MarkedAsPaid = false;
    this.invs3Found = null;
    this.invs4Found = null;
    this.inv4MarkedAsPaid = false;
    this.invSearch3 = null;
    this.invSearch4 = null;
  }

  refreshData() {
    this.revolutService.get(this.revolutTransactionLegId).subscribe( result => {
      this.revolutTransactionLeg = result;
    });
    this.getPrevNext(this.revolutTransactionLegId);
  }

  getNotLinkedTableFilters() {
    if (this.type === 'linked') {
      return getTableFilters('revolutTransactionLegTable');
    }

    if ( this.type === 'not-linked') {
      return  getTableFilters('revolutTransactionLegTable-notlinked');
    }



    return '';
  }

  getPrevNext(id: number) {
    const filters = this.getNotLinkedTableFilters();
    // console.log(filters);
    this.revolutService.getPrevNext(filters, id).subscribe(result => {
      this.prevNext = result;
    });
  }

  gotoPrevTrans() {
    const filters = this.getNotLinkedTableFilters();
    this.revolutService.getPrev(filters, this.revolutTransactionLegId).subscribe(result => {
      this.router.navigate(['/loads/annual-fee/' + result + '/' + this.type]);
    });

  }

  gotoNextTrans() {
    const filters = this.getNotLinkedTableFilters();
    this.revolutService.getNext(filters, this.revolutTransactionLegId).subscribe(result => {
      this.router.navigate(['/loads/annual-fee/' + result + '/' + this.type]);
    });
  }

  currentUserIsAdmin(): boolean {
    return this.roleService.hasRoles('admin');
  }
  currentUserIsSuperAdmin(): boolean {
    return this.roleService.hasRoles( 'super_admin' );
  }




  onSearchInv1() {
    if (this.invSearch1 == null || (this.invSearch1.length <= 3)) {
      return;
    }

    this.invs1Found = null;
    this.invSearch1Loading = true;
    this.revolutService.searchInvoices(this.invSearch1).subscribe(result => {
      if ( result != null && result.length > 0 ) {
        this.invs1Found = result;
      }
      this.invSearch1Loading = false;
    });
  }

  onSearchInv2() {
    if (this.invSearch2 == null || (this.invSearch2.length <= 3)) {
      return;
    }

    this.invs2Found = null;
    this.invSearch2Loading = true;
    this.revolutService.searchInvoices(this.invSearch2).subscribe(result => {
      if ( result != null && result.length > 0 ) {
        this.invs2Found = result;
      }
      this.invSearch2Loading = false;
    });
  }

  onSearchInv3() {
    if (this.invSearch3 == null || (this.invSearch3.length <= 3)) {
      return;
    }

    this.invs3Found = null;
    this.invSearch3Loading = true;
    this.revolutService.searchInvoices(this.invSearch3).subscribe(result => {
      if ( result != null && result.length > 0 ) {
        this.invs3Found = result;
      }
      this.invSearch3Loading = false;
    });
  }

  onSearchInv4() {

    if (this.invSearch4 == null || (this.invSearch4.length <= 3)) {
      return;
    }

    this.invs4Found = null;
    this.invSearch4Loading = true;
    this.revolutService.searchInvoices(this.invSearch4).subscribe(result => {
      if ( result != null && result.length > 0 ) {
        this.invs4Found = result;
      }
      this.invSearch4Loading = false;
    });
  }



  linkInvoice(invId: number, nr: number) {
    this.isBusy = true;
    this.revolutService.linkTransactionToInvoice(this.revolutTransactionLegId, invId, nr).subscribe(result => {
      this.isBusy = false;
      // this.clearFound();
      this.refreshData();
    }, err => {
      this.isBusy = false;
      this.showError(err.error.message || err.error || err.message || err);
    });
  }

  unlinkInvoice(invId: number, nr: number) {


    this.dialog.open(ConfirmDialogComponent,{
      data:{
        title: 'Unlink Invoice',
        text:'Are you sure you want to unlink this invoice?',
        confirm: 'Ok',
        cancel: 'Cancel'
      },
    }).afterClosed()
      .subscribe(dlgResult => {
        if (dlgResult == 'ok') {

          this.isBusy = true;
          this.revolutService.unlinkTransactionToInvoice(this.revolutTransactionLegId, invId, nr).subscribe(result => {
            this.isBusy = false;
            // this.clearFound();
            this.refreshData();
          }, err => {
            this.isBusy = false;
            this.showError(err.error.message || err.error || err.message || err);
          });

        }
      });


  }



  showSuccess(message) {
    this._toastService.success(message);
  }
  showInfo(message) {
    this._toastService.info(message);
  }
  showError(message) {
    this._toastService.error(message);
  }

  getRevolutTransactionStateText(transactionState: number): string {
    if ( transactionState == 1) {
      return 'Pending';
    }
    if ( transactionState == 2) {
      return 'Completed';
    }
    if ( transactionState == 3) {
      return 'Declined';
    }
    if ( transactionState == 4) {
      return 'Failed';
    }
    if ( transactionState == 5) {
      return 'Reverted';
    }

    return 'Other';
  }
}
